import React, { useState, useEffect } from "react";

import useFetchObjectByPost from "../../../../components/Hooks/useFetchObjectByPost";
import { sto } from "../../../../Context/InshData";
import { uri } from "../../../../help/Api";
import LoadingPage from "../../../../services/LoadingPage";
import ItemsMovementTotal from "./ItemsMovementTotal";
const defaultAutos = {
  Safes: [],
};

export default function ItemsMovementTotalCon() {
  
  const tb2 = {
    Safe: true,
    SafeEmp:true,
    EmpItems:true,
    stor: sto,
    parms: { 
        branch: sto.branchi  ,
        iempid: sto.empi,
     },

  };

  const { object: AutoOptionsB, fetching: fetchAllS } = useFetchObjectByPost(
    uri + "GetD",
    tb2,
  );
  const tb = {
    wait: true,
    // Safes: true,
    // Currencies: true,
    Branches: true,
    // groups: true,
    costcenters: true,
    stor: sto,
    parms: { safe: -1},
  };

  const { object: AutoOptions, fetching: fetchAll } = useFetchObjectByPost(
    uri + "Rept",
    tb
  );

  if (fetchAll || !AutoOptionsB?.Safes|| !AutoOptionsB?.items) return <LoadingPage />;

  return (
    <ItemsMovementTotal
      {...{
        AutoOptions: AutoOptions?.Branches ? AutoOptions : defaultAutos,
        AutoOptionsB,
        // SafeEmp:AutoOptionsB?.SafeEmp ,
        // Safes:AutoOptionsB?.Safes ,
        // Items:AutoOptionsB?.items ,

      }}
    />
  );
}
